
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.8.0
 * Query Engine version: 0a83d8541752d7582de2ebc1ece46519ce72a848
 */
Prisma.prismaVersion = {
  client: "5.8.0",
  engine: "0a83d8541752d7582de2ebc1ece46519ce72a848"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ListingScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  property_type: 'property_type',
  listing_type: 'listing_type',
  usage_type: 'usage_type',
  building_listing_type: 'building_listing_type',
  payment_frequency: 'payment_frequency',
  seller_id: 'seller_id',
  title: 'title',
  title_en: 'title_en',
  description: 'description',
  description_en: 'description_en',
  price: 'price',
  price_label: 'price_label',
  size: 'size',
  size_unit: 'size_unit',
  currency: 'currency',
  price_negotiable: 'price_negotiable',
  thumbnail_file_name: 'thumbnail_file_name',
  locationId: 'locationId',
  installment_allowed: 'installment_allowed',
  installment_duration: 'installment_duration',
  installment_duration_unit: 'installment_duration_unit',
  down_payment_amount: 'down_payment_amount',
  price_is_per_size: 'price_is_per_size',
  is_project: 'is_project',
  buy_out_price: 'buy_out_price',
  price_by_installment: 'price_by_installment',
  popular_landmark: 'popular_landmark',
  publish_status: 'publish_status',
  deleted: 'deleted',
  for_agriculture: 'for_agriculture',
  for_commercial: 'for_commercial',
  for_residential: 'for_residential',
  for_industrial: 'for_industrial',
  is_parent_listing: 'is_parent_listing',
  parent_listing_id: 'parent_listing_id',
  raw_listing_data_id: 'raw_listing_data_id',
  min_sub_listing_size: 'min_sub_listing_size',
  max_sub_listing_size: 'max_sub_listing_size',
  lowest_child_listing_price: 'lowest_child_listing_price',
  highest_child_listing_price: 'highest_child_listing_price',
  raw_data_id: 'raw_data_id',
  number_of_bedrooms: 'number_of_bedrooms',
  has_master_bedroom: 'has_master_bedroom',
  is_apartment: 'is_apartment',
  is_furnished: 'is_furnished',
  sync_date: 'sync_date',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  approval_token: 'approval_token',
  deleted_at: 'deleted_at',
  deleted_by: 'deleted_by'
};

exports.Prisma.RawListingDataScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  seller_id: 'seller_id',
  sync_source_post_id: 'sync_source_post_id',
  sync_fetched_data: 'sync_fetched_data',
  sync_date: 'sync_date',
  processing_status: 'processing_status',
  processing_start_date: 'processing_start_date',
  processing_end_date: 'processing_end_date',
  processing_feedback: 'processing_feedback',
  media_download_status: 'media_download_status',
  media_download_feedback: 'media_download_feedback',
  media_download_start_date: 'media_download_start_date',
  media_download_end_date: 'media_download_end_date',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deleted: 'deleted',
  deleted_at: 'deleted_at',
  deleted_by: 'deleted_by'
};

exports.Prisma.SellerScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  type: 'type',
  ig_name: 'ig_name',
  ig_id: 'ig_id',
  phone: 'phone',
  whatsapp_number: 'whatsapp_number',
  email_address: 'email_address',
  bio: 'bio',
  active: 'active',
  last_sync_status: 'last_sync_status',
  last_sync_error: 'last_sync_error',
  last_sync_date: 'last_sync_date',
  is_syncing: 'is_syncing',
  allow_sync: 'allow_sync',
  thumbnail_path: 'thumbnail_path',
  profile_data: 'profile_data',
  allow_sync_profile_data: 'allow_sync_profile_data',
  last_profile_data_update: 'last_profile_data_update',
  ig_token: 'ig_token',
  ig_token_expires_at: 'ig_token_expires_at',
  deleted: 'deleted',
  deleted_at: 'deleted_at',
  deleted_by: 'deleted_by'
};

exports.Prisma.AttachmentScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  created_by: 'created_by',
  path: 'path',
  name: 'name',
  is_public: 'is_public',
  is_temporary: 'is_temporary',
  type: 'type',
  description: 'description'
};

exports.Prisma.ListingAttachmentScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  Listing_id: 'Listing_id',
  attachment_id: 'attachment_id',
  created_by: 'created_by',
  description: 'description'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  email: 'email',
  password: 'password',
  phone: 'phone',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fbId: 'fbId',
  fbEmail: 'fbEmail',
  fbToken: 'fbToken',
  fbTokenExpiresAt: 'fbTokenExpiresAt',
  fb_token_last_use: 'fb_token_last_use',
  fb_user_id: 'fb_user_id',
  google_user_id: 'google_user_id',
  fb_ig_account_id: 'fb_ig_account_id',
  fb_ig_account_username: 'fb_ig_account_username',
  deleted: 'deleted',
  deleted_at: 'deleted_at',
  deleted_by: 'deleted_by'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  description: 'description',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserRoleScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  user_id: 'user_id',
  role_id: 'role_id',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  description: 'description',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RolePermissionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  role_id: 'role_id',
  permission_id: 'permission_id',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserPermissionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  user_id: 'user_id',
  permission_id: 'permission_id',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSessionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  user_id: 'user_id',
  token: 'token',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  description: 'description',
  level_1_parent_id: 'level_1_parent_id',
  level_2_parent_id: 'level_2_parent_id',
  level: 'level',
  active: 'active',
  is_hot: 'is_hot',
  created_at: 'created_at',
  updated_at: 'updated_at',
  full_name: 'full_name',
  search_priority: 'search_priority'
};

exports.Prisma.SellerUserScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  seller_id: 'seller_id',
  user_id: 'user_id',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deleted: 'deleted',
  deleted_at: 'deleted_at',
  deleted_by: 'deleted_by'
};

exports.Prisma.SettingsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  value: 'value'
};

exports.Prisma.StatisticsScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  action: 'action',
  entityId: 'entityId',
  secondaryEntityId: 'secondaryEntityId',
  createdAt: 'createdAt',
  sourceUrl: 'sourceUrl',
  userId: 'userId',
  userIp: 'userIp'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  body: 'body',
  subject: 'subject',
  medium: 'medium',
  sender_id: 'sender_id',
  sender_type: 'sender_type',
  sender_name: 'sender_name',
  sender_email: 'sender_email',
  sender_phone: 'sender_phone',
  receiver_id: 'receiver_id',
  receiver_type: 'receiver_type',
  receiver_name: 'receiver_name',
  receiver_email: 'receiver_email',
  receiver_phone: 'receiver_phone',
  receiver_whatsapp_number: 'receiver_whatsapp_number',
  message_data: 'message_data',
  message_type: 'message_type',
  external_system_reference: 'external_system_reference',
  status_message: 'status_message',
  send_status: 'send_status',
  date_scheduled: 'date_scheduled',
  date_sent: 'date_sent',
  read: 'read',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  batch_id: 'batch_id',
  conversation_id: 'conversation_id'
};

exports.Prisma.AdminWhatsAppMessageConversationScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  user_phone: 'user_phone',
  user_display_name: 'user_display_name',
  last_message_type: 'last_message_type',
  last_message: 'last_message',
  last_message_sender: 'last_message_sender',
  last_message_is_read: 'last_message_is_read',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.MultiLocationListingLogsScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  listing_title: 'listing_title',
  listing_uuid: 'listing_uuid',
  created_at: 'created_at',
  seller_name: 'seller_name',
  listing_description: 'listing_description',
  locations_data: 'locations_data',
  extracted_data: 'extracted_data'
};

exports.Prisma.PublishedToExternalSystemScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  listing_id: 'listing_id',
  external_system: 'external_system',
  external_id: 'external_id',
  external_url: 'external_url',
  publish_status: 'publish_status',
  publish_status_message: 'publish_status_message',
  publish_date: 'publish_date',
  created_at: 'created_at',
  external_response: 'external_response'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  entity_id: 'entity_id',
  entity_name: 'entity_name',
  reference: 'reference',
  type: 'type',
  status: 'status',
  data: 'data',
  created_at: 'created_at',
  updated_at: 'updated_at',
  message: 'message',
  system_message: 'system_message'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.ListingOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  title: 'title',
  title_en: 'title_en',
  description: 'description',
  description_en: 'description_en',
  size_unit: 'size_unit',
  currency: 'currency',
  thumbnail_file_name: 'thumbnail_file_name',
  installment_duration_unit: 'installment_duration_unit',
  popular_landmark: 'popular_landmark',
  approval_token: 'approval_token',
  deleted_by: 'deleted_by'
};

exports.Prisma.RawListingDataOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  sync_source_post_id: 'sync_source_post_id',
  sync_fetched_data: 'sync_fetched_data',
  processing_feedback: 'processing_feedback',
  media_download_feedback: 'media_download_feedback',
  deleted_by: 'deleted_by'
};

exports.Prisma.SellerOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  ig_name: 'ig_name',
  ig_id: 'ig_id',
  phone: 'phone',
  whatsapp_number: 'whatsapp_number',
  email_address: 'email_address',
  bio: 'bio',
  last_sync_error: 'last_sync_error',
  thumbnail_path: 'thumbnail_path',
  profile_data: 'profile_data',
  ig_token: 'ig_token',
  deleted_by: 'deleted_by'
};

exports.Prisma.AttachmentOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  created_by: 'created_by',
  path: 'path',
  name: 'name',
  description: 'description'
};

exports.Prisma.ListingAttachmentOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  created_by: 'created_by',
  description: 'description'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  email: 'email',
  password: 'password',
  phone: 'phone',
  fbId: 'fbId',
  fbEmail: 'fbEmail',
  fbToken: 'fbToken',
  fb_user_id: 'fb_user_id',
  google_user_id: 'google_user_id',
  fb_ig_account_id: 'fb_ig_account_id',
  fb_ig_account_username: 'fb_ig_account_username',
  deleted_by: 'deleted_by'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  description: 'description'
};

exports.Prisma.UserRoleOrderByRelevanceFieldEnum = {
  uuid: 'uuid'
};

exports.Prisma.PermissionOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  description: 'description'
};

exports.Prisma.RolePermissionOrderByRelevanceFieldEnum = {
  uuid: 'uuid'
};

exports.Prisma.UserPermissionOrderByRelevanceFieldEnum = {
  uuid: 'uuid'
};

exports.Prisma.UserSessionOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  token: 'token'
};

exports.Prisma.LocationOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  name: 'name',
  description: 'description',
  full_name: 'full_name'
};

exports.Prisma.SellerUserOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  deleted_by: 'deleted_by'
};

exports.Prisma.SettingsOrderByRelevanceFieldEnum = {
  name: 'name',
  value: 'value'
};

exports.Prisma.StatisticsOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  action: 'action',
  sourceUrl: 'sourceUrl',
  userId: 'userId',
  userIp: 'userIp'
};

exports.Prisma.MessageOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  body: 'body',
  subject: 'subject',
  sender_name: 'sender_name',
  sender_email: 'sender_email',
  sender_phone: 'sender_phone',
  receiver_name: 'receiver_name',
  receiver_email: 'receiver_email',
  receiver_phone: 'receiver_phone',
  receiver_whatsapp_number: 'receiver_whatsapp_number',
  message_data: 'message_data',
  message_type: 'message_type',
  external_system_reference: 'external_system_reference',
  status_message: 'status_message'
};

exports.Prisma.AdminWhatsAppMessageConversationOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  user_phone: 'user_phone',
  user_display_name: 'user_display_name',
  last_message_type: 'last_message_type',
  last_message: 'last_message',
  last_message_sender: 'last_message_sender'
};

exports.Prisma.MultiLocationListingLogsOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  listing_title: 'listing_title',
  listing_uuid: 'listing_uuid',
  seller_name: 'seller_name',
  listing_description: 'listing_description',
  locations_data: 'locations_data',
  extracted_data: 'extracted_data'
};

exports.Prisma.PublishedToExternalSystemOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  external_system: 'external_system',
  external_id: 'external_id',
  external_url: 'external_url',
  publish_status_message: 'publish_status_message',
  external_response: 'external_response'
};

exports.Prisma.JobOrderByRelevanceFieldEnum = {
  uuid: 'uuid',
  entity_name: 'entity_name',
  reference: 'reference',
  status: 'status',
  data: 'data',
  message: 'message',
  system_message: 'system_message'
};
exports.PropertyType = exports.$Enums.PropertyType = {
  land: 'land',
  building: 'building'
};

exports.ListingType = exports.$Enums.ListingType = {
  sale: 'sale',
  rent: 'rent'
};

exports.UsageType = exports.$Enums.UsageType = {
  residential: 'residential',
  commercial: 'commercial',
  industrial: 'industrial',
  agriculture: 'agriculture'
};

exports.BuildingListingType = exports.$Enums.BuildingListingType = {
  house: 'house',
  retail_space: 'retail_space',
  office_space: 'office_space',
  warehouse: 'warehouse'
};

exports.PaymentFrequency = exports.$Enums.PaymentFrequency = {
  daily: 'daily',
  monthly: 'monthly',
  quarterly: 'quarterly',
  yearly: 'yearly'
};

exports.PriceLabel = exports.$Enums.PriceLabel = {
  per_day: 'per_day',
  per_year: 'per_year',
  per_month: 'per_month',
  per_quarter: 'per_quarter',
  per_sqm: 'per_sqm',
  per_acre: 'per_acre',
  total: 'total'
};

exports.PublishStatus = exports.$Enums.PublishStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
  requested_publish: 'requested_publish'
};

exports.ProcessingStatus = exports.$Enums.ProcessingStatus = {
  processing: 'processing',
  processed: 'processed',
  pending: 'pending',
  failed: 'failed',
  queued: 'queued'
};

exports.MediaDownloadStatus = exports.$Enums.MediaDownloadStatus = {
  pending: 'pending',
  queued: 'queued',
  downloading: 'downloading',
  downloaded: 'downloaded',
  failed: 'failed'
};

exports.SellerType = exports.$Enums.SellerType = {
  owner: 'owner',
  agent: 'agent'
};

exports.SyncStatus = exports.$Enums.SyncStatus = {
  success: 'success',
  failed: 'failed'
};

exports.AttachmentType = exports.$Enums.AttachmentType = {
  image: 'image',
  video: 'video',
  doc: 'doc'
};

exports.MessageMedium = exports.$Enums.MessageMedium = {
  email: 'email',
  sms: 'sms',
  in_app: 'in_app',
  whatsapp: 'whatsapp'
};

exports.MessageUserType = exports.$Enums.MessageUserType = {
  system: 'system',
  user: 'user',
  seller: 'seller',
  admin: 'admin'
};

exports.MessageSendStatus = exports.$Enums.MessageSendStatus = {
  sent: 'sent',
  failed: 'failed',
  scheduled: 'scheduled',
  pending: 'pending'
};

exports.JobType = exports.$Enums.JobType = {
  instagram_import: 'instagram_import'
};

exports.Prisma.ModelName = {
  Listing: 'Listing',
  RawListingData: 'RawListingData',
  Seller: 'Seller',
  Attachment: 'Attachment',
  ListingAttachment: 'ListingAttachment',
  User: 'User',
  Role: 'Role',
  UserRole: 'UserRole',
  Permission: 'Permission',
  RolePermission: 'RolePermission',
  UserPermission: 'UserPermission',
  UserSession: 'UserSession',
  Location: 'Location',
  SellerUser: 'SellerUser',
  Settings: 'Settings',
  Statistics: 'Statistics',
  Message: 'Message',
  AdminWhatsAppMessageConversation: 'AdminWhatsAppMessageConversation',
  MultiLocationListingLogs: 'MultiLocationListingLogs',
  PublishedToExternalSystem: 'PublishedToExternalSystem',
  Job: 'Job'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
